import React from 'react'
import PropTypes from 'prop-types'
import { Env } from '@morningtrain/helpers'

function WhenEnv (props) {
  const { value, path } = props

  const envValue = Env.get(path)

  if (typeof value !== 'undefined') {
    if (envValue !== value) {
      return null
    }
  } else {
    if (!envValue) {
      return null
    }
  }

  return props.children
}

WhenEnv.propTypes = {
  /**
     * Path in the ENV to find the value. It should be a string in dot notation
     */
  path: PropTypes.string.isRequired,
  /**
     * The value to match the ENV value against.
     * If not provided, a falsy check will be made on the ENV value.
     */
  value: PropTypes.any
}

export default WhenEnv
